import GuidanceRegistry from '../guidance-registry.js';

GuidanceRegistry.register({
    type: "action-item-ewf-broker-handoff",
    prompt: (guidanceItem) => "Welcome to Ameriflex! Please review the order form for this client. Once reviewed please hand off to the client's Plan Administrator.",
    briefDescription: 'Broker Handoff',
    openAction: { 
        text: "Go To Your Order Form",
        url: (guidanceItem) => `/employer/${guidanceItem.employerId}/order/${guidanceItem.orderId}`
    },
    completeAction: {
        text: "Hand off to Plan Admin"
    },
});



// WEBPACK FOOTER //
// ./src/guidance/items/guidance-broker-handoff.js